import { render, staticRenderFns } from "./MoleculeFilterTag.vue?vue&type=template&id=09023a85&scoped=true&"
import script from "./MoleculeFilterTag.vue?vue&type=script&lang=js&"
export * from "./MoleculeFilterTag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09023a85",
  null
  
)

export default component.exports